import { ElementType, ReactNode } from "react";
import { Box, SxProps, Theme, Typography } from "@mui/material";

// ----------------------------------------------------------------------

interface PageHeadingProps {
  children: ReactNode;
  subtitle?: ReactNode;
  align?: "left" | "center";
  sx?: SxProps<Theme>;
  component?: ElementType;
}

/** Título de página do redesign: DM Serif Display + subtítulo opcional */
export default function PageHeading({ children, subtitle, align = "left", sx, component = "h2" }: PageHeadingProps) {
  return (
    <Box sx={[{ mb: 3, textAlign: align }, ...(Array.isArray(sx) ? sx : [sx])] as SxProps<Theme>}>
      <Typography
        component={component}
        sx={{
          fontFamily: (theme) => theme.typography.fontFamilyDisplay,
          fontWeight: 400,
          lineHeight: 1.2,
          fontSize: { xs: "1.5rem", md: "1.9rem" },
          color: "text.primary",
        }}
      >
        {children}
      </Typography>
      {subtitle && (
        <Typography sx={{ mt: 0.5, fontSize: "0.875rem", color: "text.secondary" }}>
          {subtitle}
        </Typography>
      )}
    </Box>
  );
}
